export const AssessmentItemsVI = {
    "assessmentItem": {
        "breadcrumb": "Tiêu chí đánh giá",
        "heading": {
            "item": "Danh sách tiêu chí",
            "type": "Loại tiêu chí",
            "add": "Thêm tiêu chí",
            "update": "Cập nhật tiêu chí",
            "info": "Thông tin chung",
            "addType": "Thêm loại tiêu chí đánh giá",
            "generalInfo": "Thông tin chung",
            "assessmentScale": "Thang điểm đánh giá",
            "detail": "Chi tiết"
        },
        "label": {
            "name": "Tên tiêu chí",
            "status": "Trạng thái",
            "pointOne": "Điểm 1",
            "pointTwo": "Điểm 2",
            "pointThree": "Điểm 3",
            "pointFour": "Điểm 4",
            "pointFive": "Điểm 5",
            "exact": "Cho phép chấm điểm chính xác đến 0.5",
            "description": "Mô tả",
            "type": "Loại tiêu chí",
            "dynamic": "Là loại tiêu chí"
        },
        "placeholder": {
            "name": "Nhập Tên tiêu chí",
            "status": "Nhập Trạng thái",
            "exact": "Nhập Cho phép chấm điểm chính xác đến 0.5",
            "description": "Nhập Mô tả",
            "type": "Nhập Loại tiêu chí"
        },
        "message": {
            "add": "Thêm thành công",
            "update": "Cập nhật thành công",
            "delete": "Xóa thành công",
            "required": {
                "name": "Tên tiêu chí là bắt buộc",
                "type": "Loại tiêu chí là bắt buộc",
                "pointOne": "Mô tả điểm 1 là bắt buộc",
                "pointTwo": "Mô tả điểm 2 là bắt buộc",
                "pointThree": "Mô tả điểm 3 là bắt buộc",
                "pointFour": "Mô tả điểm 4 là bắt buộc",
                "pointFive": "Mô tả điểm 5 là bắt buộc"
            }
        },
        "value": {
            "status": {
                "actived": "Đang hoạt động",
                "inactived": "Không hoạt động"
            },
            "isExact": {
                "yes": "Có",
                "no": "Không"
            }
        }
    }
}